import {
  createContext,
  useContext,
  type SetStateAction,
  type Dispatch,
} from "react";
import { type HotelBooking } from "../../types/types";

export interface HotelBookingContextValue {
  data: HotelBooking | null;
  setData: Dispatch<SetStateAction<HotelBooking | null>>;
  availabilityToken: string | null;
  setAvailabilityToken: (token: string | null) => void;
  resetBooking: () => void;
}

export const HotelBookingContext = createContext<HotelBookingContextValue>({
  data: null,
  setData: (data) => data,
  availabilityToken: null,
  setAvailabilityToken: () => {},
  resetBooking: () => {},
});

export const useHotelBookingContext = () => useContext(HotelBookingContext);
